module.exports = __webpack_public_path__ + "static/bsas002.thumb-cc652e0dea06b72159302bb3c8f0a7d6.jpg";